'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AnimationButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _playIcon = require('./playIcon');

var _playIcon2 = _interopRequireDefault(_playIcon);

var _pauseIcon = require('./pauseIcon');

var _pauseIcon2 = _interopRequireDefault(_pauseIcon);

var _ButtonIcon = require('../../ButtonIcon');

var _ButtonIcon2 = _interopRequireDefault(_ButtonIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function AnimationButton(_ref) {
  var isAnimationPaused = _ref.isAnimationPaused,
      onClick = _ref.onClick;

  var getIcon = function getIcon() {
    if (isAnimationPaused) {
      return _react2.default.createElement(_playIcon2.default, null);
    }

    return _react2.default.createElement(_pauseIcon2.default, null);
  };

  var getAssistiveText = function getAssistiveText() {
    if (isAnimationPaused) {
      return 'Start auto-play';
    }

    return 'Stop auto-play';
  };

  return _react2.default.createElement(_ButtonIcon2.default, {
    variant: 'border-filled',
    size: 'small',
    icon: getIcon(),
    onClick: onClick,
    ariaPressed: isAnimationPaused,
    assistiveText: getAssistiveText()
  });
}

AnimationButton.propTypes = {
  isAnimationPaused: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
AnimationButton.defaultProps = {
  isAnimationPaused: true,
  onClick: function onClick() {}
};